import React, { useEffect,  useState } from "react";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";
import PayRollFilterBox from "../../../components/FilterBox/PayRollFilter/PayRollFilter";
import Profile from "./Compontes/Profile";
import Attendance from "./Compontes/Attendance";
import Salary from "./Compontes/Salary";
import Increment from "./Compontes/Increment";
import Loan from "./Compontes/Loan";
import {
  DeptList,
  EmplList,
  EmployeeProfileDtl,
  EmployeeProfile1,
  EmployeeAttendance,
  EmployeeLoanDtl,
  EmployeeIncrement,
  EmployeeSalary,
} from "../../../Redux/Slice/PayRoll/PayRollSlice";
import { Loader } from "../../../components/Loader/Loader";
import { useTheme } from "../../../Themecontext/Themecontext";

export const EmployeeProfile = () => {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { EmplLisdata, DeptListdata } = useSelector(
    (state) => state.PayRollSlice,
  );

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWPAYROLL");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWPAYROLLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  let YearId = Cookies.get("FinancialYear");

  const [isFilterLoading, setIsFilterLoading] = useState(false);

  useEffect(() => {
    dispatch(
      DeptList({
        Firm: Firm,
        Year: YearId,
      }),
    );
    dispatch(
      EmplList({
        Firm: Firm,
      }),
    );
  }, [dispatch, Firm, YearId]);
  const [filters, setFilters] = useState({
    employeeName: [],
    departmentName: [],
  });

  const [search, setSearch] = useState({
    employeeName: "",
    departmentName: "",
  });
  const [appliedFilters, setAppliedFilters] = useState({
    employeeName: [],
    departmentName: [],
  });

  const [showFilter, setShowFilter] = useState(false);

  // ================= BUTTON =================
  const actionButtons = [
    "PROFILE",
    "ATTENDANCE",
    "SALARY",
    "INCREMENT",
    "LOAN",
  ];

  const [activeComponent, setActiveComponent] = useState("PROFILE");
  const renderPage = () => {
    const commonProps = {
      departmentName: appliedFilters.departmentName,
      employeeName: appliedFilters.employeeName,
    };

    switch (activeComponent) {
      case "PROFILE":
        return <Profile {...commonProps} />;
      case "ATTENDANCE":
        return <Attendance {...commonProps} />;
      case "SALARY":
        return <Salary {...commonProps} />;
      case "INCREMENT":
        return <Increment {...commonProps} />;
      case "LOAN":
        return <Loan {...commonProps} />;
      default:
        return <Profile {...commonProps} />;
    }
  };
  // ================= COMMON =================

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      if (type === "employeeName") {
        return {
          ...prev,
          employeeName: [item.value],
        };
      }

      // Multi select for other filters
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const applyFilters = async () => {
    if (!filters.employeeName?.length) {
      alert("Please Select Employee Name");
      return;
    }

    setIsFilterLoading(true);

    const EmplIDs = filters.employeeName.toString();
    const DeptIDs = filters.departmentName.toString();

    setAppliedFilters({
      employeeName: filters.employeeName,
      departmentName: filters.departmentName,
    });

    try {
      if (activeComponent === "PROFILE") {
        await Promise.all([
          dispatch(
            EmployeeProfileDtl({
              Firm,
              Year: YearId,
              EmplIDs,
              DeptGrpIDs: DeptIDs,
            }),
          ),

          dispatch(
            EmployeeProfile1({
              Firm,
              Year: YearId,
              EmplIDs,
            }),
          ),
        ]);
      }

      if (activeComponent === "ATTENDANCE") {
        await Promise.all([
          dispatch(
            EmployeeAttendance({
              Firm,
              Year: YearId,
              EmplIDs,
              DeptGrpIDs: DeptIDs,
            }),
          ),

          dispatch(
            EmployeeProfile1({
              Firm,
              Year: YearId,
              EmplIDs,
            }),
          ),
        ]);
      }

      if (activeComponent === "SALARY") {
        await Promise.all([
          dispatch(
            EmployeeSalary({
              Firm,
              Year: YearId,
              EmplIDs,
              DeptGrpIDs: DeptIDs,
            }),
          ),

          dispatch(
            EmployeeProfile1({
              Firm,
              Year: YearId,
              EmplIDs,
            }),
          ),
        ]);
      }

      if (activeComponent === "INCREMENT") {
        await Promise.all([
          dispatch(
            EmployeeIncrement({
              Firm,
              Year: YearId,
              EmplIDs,
              DeptGrpIDs: DeptIDs,
            }),
          ),

          dispatch(
            EmployeeProfile1({
              Firm,
              Year: YearId,
              EmplIDs,
            }),
          ),
        ]);
      }

      if (activeComponent === "LOAN") {
        await Promise.all([
          dispatch(
            EmployeeLoanDtl({
              Firm,
              Year: YearId,
              EmplIDs,
              DeptGrpIDs: DeptIDs,
            }),
          ),

          dispatch(
            EmployeeProfile1({
              Firm,
              Year: YearId,
              EmplIDs,
            }),
          ),
        ]);
      }
    } finally {
      setIsFilterLoading(false);
    }
  };
  const handleComponentChange = (btn) => {
    setActiveComponent(btn);

    if (appliedFilters.employeeName.length > 0) {
      const EmplIDs = appliedFilters.employeeName.toString();
      const DeptIDs = appliedFilters.departmentName.toString();

      if (btn === "PROFILE") {
        dispatch(
          EmployeeProfileDtl({
            Firm,
            Year: YearId,
            EmplIDs,
            DeptGrpIDs: DeptIDs,
          }),
        );

        dispatch(
          EmployeeProfile1({
            Firm,
            Year: YearId,
            EmplIDs,
          }),
        );
      }

      if (btn === "ATTENDANCE") {
        dispatch(
          EmployeeAttendance({
            Firm,
            Year: YearId,
            EmplIDs,
            DeptGrpIDs: DeptIDs,
          }),
        );
      }

      if (btn === "SALARY") {
        dispatch(
          EmployeeSalary({
            Firm,
            Year: YearId,
            EmplIDs,
            DeptGrpIDs: DeptIDs,
          }),
        );
      }

      if (btn === "INCREMENT") {
        dispatch(
          EmployeeIncrement({
            Firm,
            Year: YearId,
            EmplIDs,
            DeptGrpIDs: DeptIDs,
          }),
        );
      }
      if (btn === "LOAN") {
        dispatch(
          EmployeeLoanDtl({
            Firm,
            Year: YearId,
            EmplIDs,
            DeptGrpIDs: DeptIDs,
          }),
        );
      }
    }
  };
  // ================= DUMMY DATA =================
  const employeeList =
    EmplLisdata?.Data?.map((item) => ({
      label: item?.EmplName,
      value: item?.EmplDtlID,
    })) || [];
  const departmentList =
    DeptListdata?.Data?.map((item) => ({
      label: item?.Department,
      value: item?.DeptID,
    })) || [];

  if (DeptListdata === null || EmplLisdata === null || isFilterLoading) {
    return (
      <div
        style={{ height: "100vh" }}
        className="d-flex justify-content-center align-items-center"
      >
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      <style>
        {`
  .hover-scale-btn {
    transition: transform 0.2s ease-in-out;
    transform: scale(1);
  }

  .hover-scale-btn:hover {
    transform: scale(1.02);
  }

  @media (min-width: 1200px) {
    .custom-btn-col {
      flex: 0 0 20% !important;
      max-width: 20% !important;
    }
  }
`}
      </style>
      {/* MOBILE BUTTON */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>
      {/* OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={() => setShowFilter(false)}
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header
          closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
        >
          <Offcanvas.Title
            style={{
              color:
                isdark === "light"
                  ? iscolour?.Colour12
                  : iscolourDark?.Colour12,
            }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <PayRollFilterBox
              title="Employee Name"
              items={employeeList}
              search={search.employeeName}
              setSearch={(val) => handleSearch("employeeName", val)}
              selectedItems={filters.employeeName}
              toggleItem={(item) => toggleItem("employeeName", item)}
              selectAll={() => selectAll("employeeName", employeeList)}
            />

            <PayRollFilterBox
              title="Department"
              items={departmentList}
              search={search.departmentName}
              setSearch={(val) => handleSearch("departmentName", val)}
              selectedItems={filters.departmentName}
              toggleItem={(item) => toggleItem("departmentName", item)}
              selectAll={() => selectAll("departmentName", departmentList)}
            />
            <Button
              onClick={applyFilters}
              style={{
                width: "100%",
                // height: "44px",
                padding: "12px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Row className="g-4">
        {/* FILTER */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <PayRollFilterBox
              title="Employee Name"
              items={employeeList}
              search={search.employeeName}
              setSearch={(val) => handleSearch("employeeName", val)}
              selectedItems={filters.employeeName}
              toggleItem={(item) => toggleItem("employeeName", item)}
              selectAll={() => selectAll("employeeName", employeeList)}
            />
            <PayRollFilterBox
              title="Department"
              items={departmentList}
              search={search.departmentName}
              setSearch={(val) => handleSearch("departmentName", val)}
              selectedItems={filters.departmentName}
              toggleItem={(item) => toggleItem("departmentName", item)}
              selectAll={() => selectAll("departmentName", departmentList)}
            />
            <Button
              onClick={applyFilters}
              style={{
                width: "100%",
                // height: "44px",
                padding: "12px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col xl={9} lg={8}>
          <Row className="g-2 mb-3">
            {actionButtons.map((btn, index) => {
              const isActive = activeComponent === btn;

              return (
                <Col
                  key={index}
                  xs={12}
                  sm={4}
                  md={4}
                  lg={4}
                  xl={2}
                  className="custom-btn-col"
                >
                  <button
                    onClick={() => handleComponentChange(btn)}
                    className="hover-scale-btn"
                    style={{
                      width: "100%",
                      height: "58px",
                      backgroundColor: isActive
                        ? isdark === "light"
                          ? iscolour?.Colour6
                          : iscolourDark?.Colour7
                        : isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour3,
                      border: `2px solid ${isActive
                          ? isdark === "light"
                            ? iscolour?.Colour6
                            : iscolourDark?.Colour7
                          : isdark === "light"
                            ? iscolour?.Colour6
                            : iscolourDark?.Colour7
                        }`,
                      borderRadius: "14px",
                      fontWeight: "bold",
                      color: isActive
                        ? "#fff"
                        : isdark === "light"
                          ? iscolour?.Colour11
                          : iscolourDark?.Colour12,
                    }}
                  >
                    {btn}
                  </button>
                </Col>
              );
            })}
          </Row>
          {renderPage()}
        </Col>
      </Row>
    </div>
  );
};
